import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';

const UserTableRow = ({ user }) => {
    return (
        <tr>
            <td>{user.id}</td>
            <td>{user.attributes.firstName}</td>
            <td>{user.attributes.lastName}</td>
            <td>{user.attributes.officeLocation}</td>
            <td>{user.attributes.projectRole}</td>
            <td>{user.attributes.availability}</td>
            <td className="table-buttons">
                <Link to={'/staff/view/' + user.id} className="view" data-icon="&#xe91a;" data-tooltip="View">view</Link>
                <Link to={'/staff/edit/' + user.id} className="edit" data-icon="&#xe909;" data-tooltip="Edit">edit</Link>
            </td>
        </tr>
    );
};

UserTableRow.propTypes = {
    user: PropTypes.object.isRequired
};

export default UserTableRow;



// WEBPACK FOOTER //
// ./src/components/users/UserTableRow.js